import { render, staticRenderFns } from "./informacoes-aeronave.vue?vue&type=template&id=9f98964e"
import script from "./informacoes-aeronave.vue?vue&type=script&lang=js"
export * from "./informacoes-aeronave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports